var $ = require('jquery');

var productsizeutil = {
    activateRegionGroup: function (regionGroups, selectedRegion) {
        $(regionGroups).removeClass('active activeSize');
        $(regionGroups)
            .filter(function () {
                return $(this).attr('id') === selectedRegion;
            })
            .addClass('active activeSize');
    },

    changeSizeRegion: function (clickedRegion) {
        var $containers = $('.availability-reminder .attribute.size'); // change all instances for Product Sets
        var $regionGroups = $containers.find('.sizes .RegionGroup');
        var selectedRegion = '';
        if ($(clickedRegion).hasClass('form-row-radio')) {
            selectedRegion = $(clickedRegion).find('input').val();
            var $selectedRadios = $containers.find('input[value="' + selectedRegion + '"]');

            this.activateRegionGroup($regionGroups, selectedRegion);

            if ($selectedRadios && $selectedRadios.length > 1) {
                $selectedRadios.parent('span').addClass('checked');
            }
        } else {
            var firstRegion = $(clickedRegion).first();
            if (firstRegion.length > 0) {
                selectedRegion = firstRegion.text();
            }

            var $tabLinks = $containers.find('.size-region a');

            $tabLinks.each(function () {
                $(this).removeClass('tab-selected');
                $(this).attr('aria-selected', 'false');
            });
            $(clickedRegion).addClass('tab-selected');
            $(clickedRegion).attr('aria-selected', 'true');

            this.activateRegionGroup($regionGroups, selectedRegion);
        }
    }
};

module.exports = productsizeutil;
